var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.type==='FAI')?_c('font-awesome-icon',{attrs:{"icon":_vm.iconObj}}):_c('i',{class:_vm.iconObj,attrs:{"aria-hidden":"true"}})}
var staticRenderFns = []

export { render, staticRenderFns }